
export default function AerialHeroSection() {
  return (
    <section className="bg-[#FCF8F8]">
      <div className="max-w-7xl mx-auto px-6">
        <h1 className="text-xl lg:text-2xl font-bold text-[#00889D] py-8 leading-tight">Aerial</h1>
        <div className="grid lg:grid-cols-2 items-start">
          {/* Left Content */}
          <div className="space-y-8">
            <p className="text-gray-700 text-lg leading-relaxed">
              Discover a new way to move and connect with your body in our <span
                className="text-[#00889D] font-semibold">Aerial
                Workshops</span>. Supported by soft, secure hammocks, you’ll explore traditional
              yoga postures with a sense of lightness and freedom that enhances flexibility,
              builds strength, and relieves pressure on the spine and joints. The gentle
              support of the fabric allows you to move beyond the limits of the mat - improving alignment, deepening
              balance, and inviting playful exploration in a
              safe, supportive space. What makes aerial yoga special:
            </p>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                <h3 className="text-[#00889D] font-semibold text-lg mb-3">Decompression & Spine Health:</h3>
                <p className="text-gray-700 text-sm">
                  Inversions and suspended postures relieve
                  pressure and lengthen the spine.
                </p>
              </div>

              <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                <h3 className="text-[#00889D] font-semibold text-lg mb-3">Full-body Strength:</h3>
                <p className="text-gray-700 text-sm">
                  Using your body weight against gravity builds core, upper
                  body, and stabilizing muscles.
                </p>
              </div>

              <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                <h3 className="text-[#00889D] font-semibold text-lg mb-3">Improved Flexibility:</h3>
                <p className="text-gray-700 text-sm">
                  Supportive hammocks help you stretch deeper and
                  explore new ranges of motion.
                </p>
              </div>

              <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                <h3 className="text-[#00889D] font-semibold text-lg mb-3">Mindful Playfulness:</h3>
                <p className="text-gray-700 text-sm">
                  The sense of lightness and freedom encourages joy,
                  confidence, and body awareness.
                </p>
              </div>
            </div>

            <p className="text-gray-700 text-lg leading-relaxed py-6">
              Elevate your practice and experience yoga from a whole new perspective.
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center">
            <img
                src="/img/aerialHero.png"
                alt="Aerial Yoga Studio"
                className="w-full h-auto rounded-2xl shadow-xl object-cover max-w-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
